import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Menu as MenuIcon,
  PhotoAlbum as PhotoAlbumIcon,
} from '@mui/icons-material';
import { useAlbum } from '../../contexts/AlbumContext';

const AppHeader = () => {
  const { step, albumName, prevStep, resetApp } = useAlbum();

  const handleBack = () => {
    if (step === 1) {
      resetApp();
    } else {
      prevStep();
    }
  };

  return (
    <AppBar position="fixed" color="primary" elevation={0}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="back"
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          <ArrowBackIcon />
        </IconButton>

        <PhotoAlbumIcon sx={{ mr: 1 }} />

        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {albumName || 'Travel Album'}
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
